// src/hooks/useUnreadNotificationsCount.js - VERSION AVEC AUTHCONTEXT
import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../context/AuthContext'; // ✅ UTILISER LE CONTEXT EXISTANT

export const useUnreadNotificationsCount = () => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [forceRefreshCounter, setForceRefreshCounter] = useState(Date.now());
  
  // ✅ UTILISER LE HOOK AUTH EXISTANT
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      console.log('🚨 NOTIF-TIMELINE: userId manquant');
      setLoading(false);
      setCount(0);
      return;
    }

    console.log('🔄 NOTIF-TIMELINE: *** INITIALISATION HOOK ***');
    console.log('🔄 NOTIF-TIMELINE: userId:', user.uid);

    let unsubscribe = null;

    try {
      // ✅ REQUÊTE STRICTE : SEULEMENT les notifications pour CET utilisateur
      const q = query(
        collection(db, 'notifications'),
        where('userId', '==', user.uid), // 🔧 FILTRAGE STRICT par userId
        orderBy('createdAt', 'desc'),
        limit(100) // Limiter pour les performances
      );

      console.log('🔄 NOTIF-TIMELINE: Configuration du listener avec filtrage strict userId...');

      unsubscribe = onSnapshot(q, (querySnapshot) => {
        console.log('📡 NOTIF-TIMELINE: *** NOUVEAU SNAPSHOT REÇU ***');
        console.log('📡 NOTIF-TIMELINE: Nombre de notifications (filtrées par userId):', querySnapshot.docs.length);
        console.log('📡 NOTIF-TIMELINE: Timestamp:', new Date().toLocaleTimeString());
        
        let totalUnreadNotifications = 0;
        let debugNotifications = [];
        
        querySnapshot.docs.forEach((doc, index) => {
          const data = doc.data();
          
          console.log(`📄 NOTIF-TIMELINE: === NOTIFICATION ${index + 1} ===`);
          console.log(`📄 NOTIF-TIMELINE: ID: ${doc.id}`);
          console.log(`📄 NOTIF-TIMELINE: Title: ${data.title}`);
          console.log(`📄 NOTIF-TIMELINE: UserId: ${data.userId}`);
          console.log(`📄 NOTIF-TIMELINE: Type: ${data.type}`);
          
          // ✅ VERIFICATION DOUBLE SÉCURITÉ : Vérifier encore une fois l'userId
          if (data.userId !== user.uid) {
            console.log(`❌ NOTIF-TIMELINE: Notification exclue (userId différent): ${data.title} userId: ${data.userId} vs ${user.uid}`);
            return; // Ignorer cette notification
          }
          
          console.log(`✅ NOTIF-TIMELINE: Notification incluse (userId correct): ${data.title}`);
          
          // Vérifier si la notification est non lue
          const isRead = data.lu || data.read;
          const isDeleted = data.deleted;
          const isArchived = data.archived;
          
          console.log(`📊 NOTIF-TIMELINE: Statuts - lu: ${data.lu}, read: ${data.read}, deleted: ${isDeleted}, archived: ${isArchived}`);
          
          if (!isRead && !isDeleted && !isArchived) {
            totalUnreadNotifications++;
            console.log(`🔴 NOTIF-TIMELINE: Notification NON LUE comptée: ${data.title}`);
            
            debugNotifications.push({
              id: doc.id,
              title: data.title,
              userId: data.userId,
              type: data.type,
              read: isRead
            });
          } else {
            if (isRead) {
              console.log(`✅ NOTIF-TIMELINE: Notification exclue (déjà lue): ${data.title}`);
            } else if (isDeleted) {
              console.log(`🗑️ NOTIF-TIMELINE: Notification exclue (supprimée): ${data.title}`);
            } else if (isArchived) {
              console.log(`📦 NOTIF-TIMELINE: Notification exclue (archivée): ${data.title}`);
            }
          }
        });
        
        console.log('🎯 NOTIF-TIMELINE: *** RÉSUMÉ FINAL ***');
        console.log('🎯 NOTIF-TIMELINE: Notifications non lues pour cet utilisateur:', debugNotifications);
        console.log('🎯 NOTIF-TIMELINE: Comptage final:', totalUnreadNotifications);
        console.log('🎯 NOTIF-TIMELINE: Ancien count:', count);
        console.log('🎯 NOTIF-TIMELINE: Nouveau count:', totalUnreadNotifications);
        
        if (count !== totalUnreadNotifications) {
          console.log('🔥 NOTIF-TIMELINE: *** CHANGEMENT DÉTECTÉ ***');
          console.log(`🔥 NOTIF-TIMELINE: ${count} → ${totalUnreadNotifications}`);
        } else {
          console.log('⚪ NOTIF-TIMELINE: Pas de changement dans le count');
        }
        
        setCount(totalUnreadNotifications);
        setLoading(false);
        
      }, (error) => {
        console.error('❌ NOTIF-TIMELINE: *** ERREUR LISTENER ***');
        console.error('❌ NOTIF-TIMELINE:', error);
        
        if (error.code === 'failed-precondition' && error.message.includes('index')) {
          console.error('❌ NOTIF-TIMELINE: Index Firebase manquant!');
          console.error('❌ NOTIF-TIMELINE: Collection: notifications, Champs: userId + createdAt');
        }
        
        setLoading(false);
        setCount(0);
      });

    } catch (error) {
      console.error('❌ NOTIF-TIMELINE: Erreur d\'initialisation:', error);
      setLoading(false);
      setCount(0);
    }

    // ✅ Listeners pour les événements de rafraîchissement
    const handleTimelineStepEvent = (event) => {
      console.log('🔄 NOTIF-TIMELINE: *** ÉVÉNEMENT REÇU ***', event.type, event.detail);
      
      // Délai pour permettre à Firestore de se synchroniser
      const delay = event.type === 'timelineStepUpdated' ? 1500 : 300;
      console.log('🔄 NOTIF-TIMELINE: Rafraîchissement programmé dans', delay + 'ms');
      
      setTimeout(() => {
        console.log('🔄 NOTIF-TIMELINE: ForceRefresh:', forceRefreshCounter, '→', Date.now());
        setForceRefreshCounter(Date.now());
      }, delay);
    };

    // Écouter les événements de timeline
    window.addEventListener('timelineStepUpdated', handleTimelineStepEvent);
    window.addEventListener('forceRefreshNotificationCounts', handleTimelineStepEvent);
    window.addEventListener('forceRefreshTimeline', handleTimelineStepEvent);

    // Cleanup function
    return () => {
      console.log('🔌 NOTIF-TIMELINE: *** NETTOYAGE HOOK ***');
      if (unsubscribe) {
        unsubscribe();
      }
      window.removeEventListener('timelineStepUpdated', handleTimelineStepEvent);
      window.removeEventListener('forceRefreshNotificationCounts', handleTimelineStepEvent);
      window.removeEventListener('forceRefreshTimeline', handleTimelineStepEvent);
    };

  }, [user?.uid, forceRefreshCounter]); // ✅ AJOUT DE user?.uid

  console.log('🔢 NOTIF-TIMELINE: État actuel - count:', count, 'loading:', loading);

  return { count, loading };
};